export const siteConfig = {
  // Site Information
  name: "THE KITCHEN Hip-Hop Dance Company",
  tagline: "Where young dancers learn, train, and cook up real hip-hop.",
  brandPositioning: "Urban. Competitive. High-energy.",

  // Contact Information
  contact: {
    phone: "908-507-4951",
    email: "KitchenDanceCo@gmail.com",
    address: "125 Park Ave, Madison, NJ 07940",
    hours: "Tuesday Class Hours: 4:00 PM – 8:00 PM",
    locationNote:
      "Located at Fitness for Mankind - a state-of-the-art facility featuring convenient parking and a high-quality sound system",
  },

  // Colors (easily customizable)
  colors: {
    primary: "#8B5CF6", // Purple
    accent: "#14B8A6", // Teal
    background: {
      light: "#F8FAFC",
      cream: "#FEF7ED",
      dark: "#1F2937",
    },
    text: {
      primary: "#1F2937",
      light: "#FFFFFF",
      accent: "#8B5CF6",
    },
  },

  // Social Media
  socialMedia: {
    facebook: "https://www.facebook.com/share/1FJ5smUycH/?mibextid=wwXIfr",
    instagram:
      "https://www.instagram.com/thekitchendanceco?igsh=dWxneWgwOWRiMzBx&utm_source=qr",
    youtube: "https://www.youtube.com/@thekitchendanceco",
    tiktok: "https://www.tiktok.com/@thekitchendanceco?_r=1&_t=ZT-91aqOHGK4G7",
  },
};

export const classesData = {
  acroHop: {
    name: "ACRO HOP",
    ages: "Ages 6–12",
    time: "Tuesdays 5:00–6:00 PM",
    description: "A fun mix of beginner acrobatics and hip-hop",
  },

  hipHopClasses: [
    {
      name: "Hip-Hop",
      ages: "Ages 10–12",
      time: "Tuesdays 4:00–5:00 PM",
    },
    {
      name: "Hip-Hop",
      ages: "Ages 6–9",
      time: "Tuesdays 6:00–7:00 PM",
    },
    {
      name: "Hip-Hop",
      ages: "Ages 13–18",
      time: "Tuesdays 7:00–8:00 PM",
    },
  ],

  competitive: {
    name: "URBAN & COMPETITIVE PROGRAMS",
    description:
      "Advanced training, performance development, and competition opportunities for dancers seeking next-level training, performance, and competition opportunities.",
  },
};

export const scheduleData = [
  {
    time: "4:00–5:00 PM",
    class: "Hip Hop",
    ageGroup: "Ages 10–12",
  },
  {
    time: "5:00–6:00 PM",
    class: "Acro Hop",
    ageGroup: "Ages 6–12",
  },
  {
    time: "6:00–7:00 PM",
    class: "Hip Hop",
    ageGroup: "Ages 6–9",
  },
  {
    time: "7:00–8:00 PM",
    class: "Hip Hop",
    ageGroup: "Ages 13–18",
  },
];

export const aboutData = {
  story:
    "The Kitchen Hip-Hop Dance Company, co-founded by Mr. Michael and Mr. Neal, is a youth-focused urban dance studio dedicated to building strong dancers from the ground up.",
  mission:
    "Our mission: Teach real movement. Build real skill. Create real community.",
  vibe: "Urban. High-energy. Technique-driven.",
  values: [
    "Discipline",
    "Creativity",
    "Performance quality",
    "Team culture",
    "Respect for hip-hop foundations",
  ],
};

export const instructorData = {
  description:
    "Real dancers. Real mentors. Each instructor brings authentic hip-hop roots, battle experience, and teaching passion.",
  featured: {
    name: "Mr. Michael",
    title: "Founder/Lead Instructor",
    bio: "Mr. Michael brings over 20 years of professional choreography and teaching experience. He has performed with artists including NSYNC and Justin Timberlake, appeared on the MTV VMAs, and choreographed for the NBA/NJ Nets dancers as well as Christina Aguilera, Pink, Ariana Grande, and America's Got Talent.",
  },
};

export const offeringsData = [
  {
    title: "Authentic Hip-Hop Training",
    description: "Real foundations, real drills, real growth",
  },
  {
    title: "Urban & Competitive Programs",
    description: "Recreational through advanced competitive training",
  },
  {
    title: "Ages 4–18",
    description: "Beginner to advanced levels",
  },
];

export const whyChooseData = [
  "Real hip-hop technique",
  "Small class sizes",
  "Experienced instructors",
  "Competitive opportunities",
];
